import React, { useMemo, useState } from 'react'
import { Col, Input, Row, Spin, Form, Button, FormInstance } from 'antd'
import useSingleBroadcast from 'hooks/useSingleBroadcast'
import { QuickReplyIntent } from 'types'
import { RiCloseCircleLine, RiEyeLine, RiFlowChart } from 'react-icons/ri'
import { BroadcastFormValues } from 'component/Broadcast/BroadcastDetails'
import BroadcastCampaignPanel from 'component/Broadcast/BroadcastPanels/BroadcastFormSettings/BroadcastCampaignPanel'
import styles from './styles.module.scss'

const { Item } = Form

interface Props {
	form: FormInstance<BroadcastFormValues>
}

const BroadcastFormSettings: React.FC<Props> = ({ form }) => {
	const { broadcast, loading: broadcastLoading } = useSingleBroadcast()

	const [viewDefaultAction, setViewDefaultAction] = useState(false)

	const template = useMemo(
		() =>
			typeof broadcast?.template !== 'string' &&
			broadcast?.template !== null &&
			broadcast?.template !== undefined
				? broadcast.template
				: null,
		[broadcast?.template]
	)

	const handlePanelShowChange = (show: boolean) => {
		setViewDefaultAction(show)
	}

	const handleViewDefaultAction = () => {
		setViewDefaultAction(true)
	}

	const hasDefaultReplyIntent = form
		.getFieldValue('qrBtnActionSetting')
		.some((intent: QuickReplyIntent) => intent.index === -1)

	return (
		<>
			<Spin spinning={broadcastLoading}>
				<Row gutter={16}>
					<Col span={8}>
						<p className={styles.title}>Default Reply Action</p>
						<Item>
							<Button
								type={hasDefaultReplyIntent ? 'primary' : 'ghost'}
								htmlType='button'
								onClick={() => handleViewDefaultAction()}
								icon={hasDefaultReplyIntent ? <RiEyeLine /> : <RiCloseCircleLine />}
								className={styles.qrButton}
								disabled={!hasDefaultReplyIntent}
							>
								{hasDefaultReplyIntent ? 'View' : 'No'} Action
							</Button>
						</Item>
						<p
							className={styles.title}
							hidden={template?.action?.type !== 'QUICK_REPLY'}
						>
							Quick Reply Button Actions
						</p>
						{template?.action?.type === 'QUICK_REPLY' &&
							template.action.items.map((item, index) => (
								<Item key={typeof item === 'string' ? item : index}>
									<div className='quick-reply'>
										<Input
											disabled
											value={typeof item === 'string' ? item : ''}
											className='quick-reply-input'
										/>
									</div>
								</Item>
							))}
					</Col>
				</Row>
			</Spin>
			<BroadcastCampaignPanel
				icon={<RiFlowChart />}
				show={viewDefaultAction}
				title='Reply Actions'
				setShow={handlePanelShowChange}
				className={styles.panel}
				form={form}
			/>
		</>
	)
}

export default BroadcastFormSettings
